import { useMemo } from 'react'
import { useSelector } from 'react-redux'
import { arrangeColumns } from '@user/components/xGrid'
import {
  selectRolesColumnOrder,
  useLoadListViewPreferencesOnce,
} from '@user/store/userPreferences'
import { GridDensity, useGridApiRef } from '@mui/x-data-grid-pro'
import { rolesListColumns } from '@user/components/Settings/Roles/hooks/tableColumn'
import { Role } from '@user/store/roles/typings'

interface Props {
  handleEditClick: (role: Role) => void
  handleDeleteRequest: (rolId: number) => void
  densityMode: GridDensity
}

export const useGetColumnData = (props: Props) => {
  const { handleEditClick, handleDeleteRequest, densityMode } = props
  const userPrefsLoading = useLoadListViewPreferencesOnce()
  const apiRef = useGridApiRef()

  const columnOrder = useSelector(selectRolesColumnOrder)
  const [columns, columnVisibility] = useMemo(
    () =>
      arrangeColumns(
        columnOrder,
        rolesListColumns({
          handleEditClick,
          handleDeleteRequest,
          densityMode,
        }),
        [],
        [],
      ),
    [columnOrder, handleEditClick, handleDeleteRequest, densityMode],
  )

  const loading = userPrefsLoading

  return { loading, columns, columnVisibility, apiRef }
}
